<template>
	<div class="equipmentfailureorabnormal mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">小程序公告配置</div>
		</div>
		<div class="mainBot">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">公告配置列表</span>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="新增参数配置"></div>
			</div>
			
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="noticeId" label="公告ID"  width="100" prop="noticeId" show-overflow-tooltip>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="noticeTitle" label="公告标题"  width="200">
							</el-table-column>
			
							<el-table-column show-overflow-tooltip prop="noticeContent" label="公告内容">
								<!-- <template slot-scope="scope">
									<span v-if="scope.row.communityName">{{scope.row.communityName}}-</span>
									<span>{{scope.row.communitySiteName}}</span>
								</template> -->
							</el-table-column>
							
							<el-table-column show-overflow-tooltip prop="noticeIndex" label="公告排序" width="100">
							</el-table-column>
							
							<el-table-column show-overflow-tooltip prop="noticeStatus" label="公告状态"  width="100">
								<template slot-scope="scope">
									<span>{{scope.row.noticeStatus==1?"上线 ":scope.row.noticeStatus==2?"下线":''}}</span>
								</template>
							</el-table-column>
							
							<el-table-column show-overflow-tooltip prop="noticeStartTime" label="公告开始时间">
							</el-table-column>
							
							<el-table-column show-overflow-tooltip prop="noticeEndTime" label="公告结束时间">
							</el-table-column>
							
							<el-table-column label="操作" width="150">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row,1)">编辑</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">删除</el-button>
								</template>
							</el-table-column>
							
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
			
		</div>
		
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<div class="dialogBox">
				<el-form :model="itemObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="公告标题" prop="noticeTitle">
								<div class="myinputBox">
									<el-input clearable v-model="itemObj.noticeTitle" placeholder="请输入公告标题">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="公告排序" prop="noticeIndex">
								<div class="myinputBox">
									<el-input clearable v-model="itemObj.noticeIndex" placeholder="请输入公告排序">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" >
						
						<div class="diaTpye disStart" >
							<el-form-item class="lableBox" label="公告状态" prop="noticeStatus">
								<div class="myinputBox">
									<el-select clearable value-key="value" v-model="itemObj.noticeStatus" slot="prepend"
										placeholder="请选择状态">
										<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="开始日期">
								<div class="myinputBox">
									<el-date-picker value-format="yyyy-MM-dd HH:mm:ss"
										v-model="itemObj.noticeStartTime" type="date" placeholder="选择日期">
									</el-date-picker>
								</div>
							</el-form-item>
						</div>
					</div>
					
					<div class="diaItem disBetween" >
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="结束日期">
								<div class="myinputBox">
									<el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"
										v-model="itemObj.noticeEndTime" type="date" placeholder="选择日期">
									</el-date-picker>
								</div>
							</el-form-item>
						</div>
					</div>
					
					<div class="diaItem disBetween" >
						<div class="diaTpye disStart">
								<el-form-item class="lableBox" label="公告内容" prop="noticeContent">
									<div class="myinputBox myinputBox4">
										<el-input type="textarea" placeholder="请输入公告内容" v-model="itemObj.noticeContent"
											resize="none">
										</el-input>
									</div>
								</el-form-item>
							
						</div>
					</div>
				</el-form>
	
		
			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="toSave('ruleForm3')" v-preventReClick="3000">确 定</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		name: "equipmentfailureorabnormal",
		data() {
			return {
				PageInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				itemObj:{},
				rules:{},
				dialogVisible: false,
				NOfalse: false,
				dialogTitle: "新增公告",
				searchObj: {
					noticeTitle: "", //公告标题
					noticeStatus: null,
					pageNo: 1, //当前页
					pageSize: 8, //当前页个数
				},
				loading: false,
				restaurants: [],
				tableData: [],
				equStatusList: [{
						text: "正常",
						value: 1
					},
					{
						text: "离线",
						value: 2
					},
					{
						text: "故障",
						value: 3
					},
				],
				operateStatusList: [{
						text: "未投用",
						value: 1
					},
					{
						text: "运营中",
						value: 2
					},
					{
						text: "已拆除",
						value: 3
					},
				],
				countList: [{
						text: "月充电次数从低到高",
						value: 1
					},
					{
						text: "月充电次数从高到低",
						value: 2
					}
				],
				statusList: [{
						text: "上线",
						value: 1
					},
					{
						text: "下线",
						value: 2
					}
				],
			}
		},
		mounted() {
			// this.listRole()
			// this.selectParamConfigByCode()
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods:{
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.dialogTitle == "新增公告") {
							that.addSysNotice()
						} else {
							that.updateSysNotice(that.itemObj)
						}
					} else {
						return false;
					}
				});
			
			},
			addSysNotice(item) {
			
				let obj = {
					noticeTitle: this.itemObj.noticeTitle,
					noticeIndex: this.itemObj.noticeIndex,
					noticeStatus: this.itemObj.noticeStatus,
					noticeStartTime: this.itemObj.noticeStartTime,
					noticeEndTime: this.itemObj.noticeEndTime,
					noticeContent: this.itemObj.noticeContent,
				
				}
				this.$api.addSysNotice(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新增账号成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			
			updateSysNotice(item) {
				let obj = {
					noticeId:item.noticeId,
					noticeTitle: item.noticeTitle,
					noticeIndex: item.noticeIndex,
					noticeStatus: item.noticeStatus,
					noticeStartTime: item.noticeStartTime,
					noticeEndTime: item.noticeEndTime,
					noticeContent: item.noticeContent,
				}
				this.$api.updateSysNotice(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '编辑账号成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			changeSelect(n) {
				this.$set(this, "stationList", [])
				this.$set(this.searchObj, "communitySiteId", "")
				this.$set(this.searchObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.searchObj, "communityName", item.communityName)
					this.$set(this.searchObj, "communityId", item.communityId)
					// if (n) {
					// 	this.$api.listAllCommunitySiteByCommunityId({
					// 		communityId: item.communityId
					// 	}).then((res) => {
					// 		if (res.returnCode == 200) {
					// 			this.$set(this, "stationList", res.obj)
					// 		}
					// 	})
					// }
				} else {
					this.$set(this.searchObj, "communityName", n)
				}
			
			
			},
			
			itemClick(item, n) { //1编辑2删除5新增
			let that=this
				if (n == 1) {
					this.$set(this, "dialogTitle", "编辑公告")
					this.$set(this, "itemObj", item)
					
					this.dialogVisible = true
				} else if (n == 2) {
					this.$confirm('是否确认删除该参数?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteSysNotice({
							noticeId: item.noticeId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
							} else {
								that.$message({
									message: res.returnMessage || "请求异常",
									type: 'error'
								});
							}
						})
					
					}).catch(() => {
					
					});
				} else if (n == 5) {
					this.$set(this, "dialogTitle", "新增公告")
					this.$set(this, "itemObj", {
						// noticeTitle: "",
						// noticeIndex: "",
						// noticeStatus: "",
						// noticeStartTime:"",
						// noticeEndTime: "",
						// noticeContent: "",
					})
					this.dialogVisible = true
				}
			},
			toSearch() {
				this.searchObj.pageNo = 1
				this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData() {
				this.loading = true
			
				this.$api.listSysNotice(this.searchObj).then((res) => {
					console.log(res)
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					}
				})
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 5000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);
			
						}
					})
			
				} else {
					this.options = [];
				}
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData()
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./listSysNotice.scss";
</style>